import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import ReturnNotes from './ReturnNotes';
import './ReturnNotes.less';

export const prefix = 'bm-p-return-notes';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: ReturnNotes,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
